import { Box } from "@mui/material"
import { ArrowDownwardOutlined, ArrowUpwardOutlined } from "@mui-symbols-material/w300"
import type { ReactNode } from "react"

import { UOM_RENDER_PRECISION } from "@/constants/formats"
import { RoundOffType } from "@/types/rounding"

interface PalettesRoundControlProps {
  roundOffType: RoundOffType
  palettesNumber: number
  palettesWeight: number
  uom: string
  onClick: () => void
}

const PalettesRoundControl = ({
  roundOffType,
  uom,
  palettesNumber,
  palettesWeight,
  onClick,
}: PalettesRoundControlProps): ReactNode => {
  return (
    <Box className='flex items-center gap-2'>
      <Box
        className='flex h-[36px] w-[32px] cursor-pointer items-center justify-center rounded border border-gray-800 p-[10px] hover:border-[#DB841F]'
        onClick={onClick}
        data-testid={`round-off-${roundOffType === RoundOffType.DOWN ? "down" : "up"}-button`}
      >
        {roundOffType === RoundOffType.DOWN ? (
          <ArrowDownwardOutlined className='hover:border-[#DB841F]' />
        ) : (
          <ArrowUpwardOutlined className='hover:border-[#DB841F]' />
        )}
      </Box>
      <Box className='block'>
        <p className='text-sm'>{roundOffType === RoundOffType.DOWN ? "Round Down" : "Round Up"}</p>
        <p className='text-sm'>
          {palettesNumber.toFixed(UOM_RENDER_PRECISION)} Pallets ({palettesWeight.toFixed(UOM_RENDER_PRECISION)} {uom})
        </p>
      </Box>
    </Box>
  )
}

export default PalettesRoundControl
